// extracted by mini-css-extract-plugin
export default {"chevron":"rotatable-chevron_chevron__1ETP5","open":"rotatable-chevron_open__C2Xfb"};